import React from 'react';
import IntlMessages from 'Util/IntlMessages';

const BasicSegmentPillBar = ({ value, onChange, menuItems, ...rest }) => {
  return (
    <div {...rest} className='basic-segment-pill-bar'>
      {menuItems.map(item => (
        <div key={item.value} className='basic-segment-pill-bar-item-wrapper'>
          <div className={`basic-segment-pill-bar-item cursor-pointer no-drag ${item.value === value ? 'checked' : ''}`} onClick={() => onChange({ target: { value: item.value } })}>
            {item.labelId ? <IntlMessages id={item.labelId} /> : item.label}
          </div>
        </div>
      ))}
    </div>
  );
};

export default BasicSegmentPillBar;
